// extracted by mini-css-extract-plugin
module.exports = {"inviteButton":"InviteBorrowerButton_inviteButton__34ACB"};